/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import CloudinaryResource from '../CloudinaryResource'
import { resolveCloudinaryResource } from '../CloudinaryResource'

const FilesExistingValue = ({
  imageFormat = 'jpg',
  maxHeight = '150px',
  maxWidth,
  onChange,
  shouldChange,
  value,
}) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null
  }

  const [id, isVideo, url] = React.useMemo(() => {
    let parsedId = value
    let isVideo = false
    let format = undefined

    if (parsedId.startsWith('video/')) {
      parsedId = parsedId.substring(6)
      isVideo = true
      format = 'mp4'
    }

    let { url } = resolveCloudinaryResource({ id: parsedId, format })

    if (isVideo) {
      url = url.replace('/image', '/video')
    }

    return [parsedId, isVideo, url]
  }, [value])

  return (
    <FilesExistingValueContainer>
      <div style={{ marginBottom: 3 }}>
        {isVideo && (
          <a target="_blank" href={url}>
            Existing video: {url}
          </a>
        )}
        {!isVideo && (
          <WrappedCloudinaryResource
            id={id}
            maxHeight={maxHeight}
            maxWidth={maxWidth}
            format={imageFormat}
          />
        )}
      </div>

      {!shouldChange && (
        <button
          type="button"
          className="btn btn-xs btn-white"
          onClick={onChange}
        >
          Replace
        </button>
      )}
      {shouldChange && (
        <button
          type="button"
          className="btn btn-xs btn-white"
          onClick={onChange}
        >
          Keep existing
        </button>
      )}
    </FilesExistingValueContainer>
  )
}

const FilesExistingValueContainer = styled.div``

export default FilesExistingValue

const WrappedCloudinaryResource = styled(CloudinaryResource)`
  max-height: ${({ maxHeight }) => maxHeight};
  max-width: ${({ maxWidth }) => maxWidth};
  background-color: #f5f5f5;
`
